<template>
  <b-container class="contendordepagina">
    <loading :active.sync="isEnviando" :is-full-page="true"></loading>

    <AlertaError
      v-if="mensajeerror.length"
      :mensajeerror="mensajeerror"
      v-on:cerrado="onAlertErrorCerrado"
    ></AlertaError>

    <div v-if="paso == -1">
      <ContratosSeleccionExpediente
        tituloh1="Paso 0 de 5. Indica el expediente del contrato que se va a enviar a firmar por via electrónica"
        v-on:expediente-seleccionado="onExpedienteSeleccionado"
      >
      </ContratosSeleccionExpediente>
    </div>
    <div v-if="paso == 1">
      <ContratosActivacionExpediente
        tituloh1="Paso 1 de 5. Indica los datos del expediente y la hoja de validación"
        v-on:expediente-activado="onExpedienteActivado"
      >
      </ContratosActivacionExpediente>
    </div>
    <div v-if="paso == 2">
      <SubirPDFaFirmar
        tituloh1="Paso 2 de 5. Sube el PDF del contrato que se va a enviar a firmar por via electrónica"
        :tipologia="tipologia"
        seccionactiva="ESPECIALES-CONTRATOSNAC"
        v-on:paso-atras="onPasoAtras"
        v-on:pdf-subido="onPDFSubido"
      >
      </SubirPDFaFirmar>
    </div>
    <div v-if="paso == 3">
      <DefinicionCaracteristicasDeFirmantes
        tituloh1="Paso 3 de 5. Firmantes del documento"
        :firmantes="datosexpediente.firmantes"
        :pdfdoc="pdfcontrato"
        :ubicacionfirmas="ubicacionfirmas"
        v-on:paso-atras="onPasoAtras"
        v-on:atributos-firmantes-definidos="onAtributosFirmatesDefinidos"
      >
      </DefinicionCaracteristicasDeFirmantes>
    </div>
    <div v-if="paso == 4">
      <EmailFirmanteManusa
        tituloh1="Paso 4 de 5. Edición del email privado que se enviará al firmante por parte de Manusa"
        :datosexpediente="datosexpediente"
        v-on:paso-atras="onPasoAtras"
        v-on:email-firmante-manusa-editado="onEmailFirmanteManusaEditado"
      ></EmailFirmanteManusa>
    </div>
    <div v-if="paso == 5">
      <ConfirmacionDelEnvioDelContrato
        tituloh1="Paso 5 de 5. Confirmación del envío"
        :datosexpediente="datosexpediente"
        v-on:paso-atras="onPasoAtras"
        v-on:envio-confirmado="onEnvioConfirmado"
      ></ConfirmacionDelEnvioDelContrato>
    </div>
    <div v-if="paso == 6">
      <ResultadoDelEnvio
        seccionactiva="ESPECIALES-CONTRATOSNAC"
        :datosdocumento="datosexpediente"
        :resultadoefirma="resultadoefirma"
      ></ResultadoDelEnvio>
    </div>
  </b-container>
</template>

<script>
import AlertaError from "@/components/AlertaError.vue";
import ContratosSeleccionExpediente from "@/components/ContratosSeleccionExpediente.vue";
import ContratosActivacionExpediente from "@/components/ContratosActivacionExpediente.vue";
import SubirPDFaFirmar from "@/components/SubirPDFaFirmar.vue";
import DefinicionCaracteristicasDeFirmantes from "@/components/DefinicionCaracteristicasDeFirmantes.vue";
import EmailFirmanteManusa from "@/components/EmailFirmanteManusa.vue";
import ConfirmacionDelEnvioDelContrato from "@/components/ConfirmacionDelEnvioDelContrato.vue";
import ResultadoDelEnvio from "@/components/ResultadoDelEnvio.vue";
import Loading from "vue-loading-overlay";
import { mapState } from "vuex";

export default {
  components: {
    AlertaError,
    ContratosSeleccionExpediente,
    ContratosActivacionExpediente,
    SubirPDFaFirmar,
    DefinicionCaracteristicasDeFirmantes,
    EmailFirmanteManusa,
    ConfirmacionDelEnvioDelContrato,
    ResultadoDelEnvio,
    Loading,
  },
  data() {
    return {
      mensajeerror: "",
      paso: 0,
      datosexpediente: null,
      pdfcontrato: "",
      pdfhojavalidacion: "",
      ubicacionfirmas: "endocumento",
      envioconfirmado: false,
      isEnviando: false,
      resultadoefirma: null,
      tipologia: "CMLCONTRATO",
    };
  },
  mounted() {
    this.$store.commit("SET_SECCION", "Envío de contrato");
    this.paso = 1;
    console.log("usuario_nombre", this.usuario_nombre);
    //modo demo
    //this.mododemo()
    console.log(
      "ejemplo",
      this.$store.getters.misTipologiasDeEFirma.filter(
        (c) => c.codigo === this.tipologia
      )[0].descripcion
    );
  },
  methods: {
    //Ejemplo de uso: console.log("Certificado De MDS", this.certificadosegunmodoysello("cdsegunsello", "selloMDS"))
    certificadosegunmodoysello: function(modofirma, selloempresa) {
      if (modofirma === "cdsegunsello") {
        const mcde = this.$store.getters.misCertificadosDeEmpresa.filter(
          (c) => c.sello === selloempresa
        )[0];
        return mcde.certificado;
      }
      return "";
    },
    onAlertErrorCerrado: function() {
      this.mensajeerror = "";
    },
    onPasoAtras: function() {
      switch (this.paso) {
        case 2:
          this.pdfcontrato = null;
          break;
      }
      this.paso--;
    },
    /**
     * @description Proviene de ContratosSeleccionExpediente.
     *    Devuelve un objeto con toda la información referente al expediente
     */
    onExpedienteSeleccionado: function(datosexpediente) {
      //console.log("datosexpediente", datosexpediente)
      this.datosexpediente = datosexpediente;
      this.paso++;
    },
    /**
     * @description Proviene de ContratosActivacionExpediente.
     *    Sube el fichero hoja de validación y se rellenan datos básicos del expediente.
     *    Devuelve un objeto con toda la información referente al expediente y el pdf de la hoja de validación
     */
    onExpedienteActivado: function(datosexpediente, pdfhojavalidacion) {
      this.datosexpediente = datosexpediente;
      this.pdfhojavalidacion = pdfhojavalidacion;
      this.paso++;
    },
    /**
     * @description Proviene de SubirPDFaFirmar.
     *    Devuelve el contenido (base64) del PDF que se enviará a firmar, con el fin de disponer de él para poderlo visualizar
     */
    onPDFSubido: function(contenidopdf) {
      //console.log("pdfsubido", pdfsubido)
      this.pdfcontrato = contenidopdf;
      this.paso++;
    },
    /**
     * @description Proviene de DefinicionCaracteristicasDeFirmantes.
     *    Devuelve, de cada firmante, la definición final de los atributos de cada firma
     */
    onAtributosFirmatesDefinidos: function(
      ubicacionfirmas,
      atributosfirmantes
    ) {
      this.datosexpediente.ubicacionfirmas = ubicacionfirmas;
      this.datosexpediente.firmantes = atributosfirmantes;
      console.log("onAtributosFirmatesDefinidos", this.datosexpediente);
      this.paso++;
    },
    /**
     * @description Proviene de EmailFirmanteManusa.
     *    Devuelve el asunto, cuerpo del mensaje y adjuntos que se enviarán al firmante de Manusa
     */
    onEmailFirmanteManusaEditado: function(emailfirmantemanusa) {
      this.datosexpediente.firmantes[0].emailpersonalizado = emailfirmantemanusa;
      this.datosexpediente.firmantes[0].emailpersonalizado.enviado = false;
      console.log("onEmailFirmanteManusaEditado", this.datosexpediente);
      this.paso++;
    },
    /**
     * @description Proviene de ConfirmacionDelEnvioDelContrato.
     *    Devuelve el cuerpo del mensaje que se enviará al firmante de Manusa
     */
    onEnvioConfirmado: function() {
      this.envioconfirmado = true;
      this.iniciarProcesoDeFirma();
      console.log("onEnvioConfirmado", this.datosexpediente);
    },
    /**
     * @description Envía la orden a la API para dar inicio al proceso de efirma del contrato, compuesta por:
     *              - Envío de correo personalizado al firmante de Manusa
     *              - Envío de orden de firma electrónica a Signaturit del contrato procesado
     *              Una vez finalizado, se muestra el resultado de la operación (en el siguiente paso)
     */
    iniciarProcesoDeFirma: function() {
      const params = {
        pdfhojavalidacion: this.pdfhojavalidacion,
        pdfcontrato: this.pdfcontrato,
        datosexpediente: this.datosexpediente,
      };
      this.isEnviando = true;
      // Se envía el email personalizado mediante API con un método específico, que genera dos PDF: hoja de validación y borrador contrato
      var _t = this;
      this.axios
        .post("efirma/enviar-email-firmante-manusa-contrato", params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.usuario_token}`,
          },
        })
        .then(function(response) {
          console.log("enviar-email-firmante-contrato", response);
          _t.datosexpediente.firmantes[0].emailpersonalizado.enviado = true;
          if (response.data.error === "") {
            // se envía la orden a signaturit para que envíe el correo de firma
            _t.enviarDocumentoAFirmar(response.data.pdfcontrato);
          } else {
            _t.mensajeerror = "ERROR: " + response.data.error;
          }
        })
        .catch(function(error) {
          console.log("enviar-email-firmante-contrato - error", error);
          _t.mensajeerror =
            "Error 1001. No se pudo enviar el email personalizado.<br />" +
            error;
        })
        .then(function() {
          _t.isEnviando = false;
        });
    },
    /**
     * @description Se envía el mediante API el contrato a firmar
     */
    enviarDocumentoAFirmar: function(pdfcontrato) {
      if (pdfcontrato.length == 0) return;

      this.pdfcontrato = pdfcontrato;
      const params = {
        nombrefichero: "contrato." + this.datosexpediente.codigo + ".pdf",
        datapdf: this.pdfcontrato,
        remitente: {
          nombre: this.usuario_nombre,
          email: this.usuario_email,
        },
        cc: [
          {
            nombre: this.usuario_nombre,
            email: this.usuario_email,
          },
        ],
        numerofirmantes: 2,
        firmantes: [
          {
            id: 1,
            mensajeprivado: "",
            nombre: this.datosexpediente.firmantes[0].nombre,
            email: "angel.ortega@manusa.com", //this.datosexpediente.firmantes[0].email,
            modofirma: this.datosexpediente.firmantes[0].modofirma,
            digital_certificate_name: this.certificadosegunmodoysello(
              this.datosexpediente.firmantes[0].modofirma,
              this.datosexpediente.firmantes[0].selloempresa
            ),
          },
          {
            id: 2,
            mensajeprivado: "",
            nombre: this.datosexpediente.firmantes[1].nombre,
            email: "angel.ortega@manusa.com", //this.datosexpediente.firmantes[1].email,
            modofirma: this.datosexpediente.firmantes[1].modofirma,
            digital_certificate_name: this.certificadosegunmodoysello(
              this.datosexpediente.firmantes[1].modofirma,
              this.datosexpediente.firmantes[1].selloempresa
            ),
          },
        ],
        emailfirmantes: {
          asunto: "Firma del contrato " + this.datosexpediente.codigo,
          cuerpo:
            "Se solicita la firma del contrato '" +
            this.datosexpediente.descripcion +
            "'.\nPara llevar a cabo la firma electrónica del mismo, se ruega se sigan las instrucciones indicadas.\nAtentamente,\n",
        },
        signing_mode: "sequential",
        data: {
          titulo: this.datosexpediente.codigo,
          tipologia_codigo: this.tipologia,
          tipologia_descripcion: this.$store.getters.misTipologiasDeEFirma.filter(
            (c) => c.codigo === this.tipologia
          )[0].descripcion,
          departamento: this.$store.getters.misTipologiasDeEFirma.filter(
            (c) => c.codigo === this.tipologia
          )[0].departamento,
        },
        modoapp: this.$store.getters.miModoApp,
      };

      this.isEnviando = true;
      // Se envía el email personalizado mediante API con un método específico, que genera dos PDF: hoja de validación y borrador contrato
      var _t = this;
      this.axios
        .post("efirma/enviar-documento-a-firmar", params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.usuario_token}`,
          },
        })
        .then(function(response) {
          console.log("enviar-documento-a-firmar", response);
          if (response.data.error === "") {
            // se da por concluido el envío y se informa del resultado
            _t.datosexpediente.procesoefirma = {
              enviadaaefirmantes: true,
              estadoefirma: "PENDIENTE",
            };
            _t.resultadoefirma = response.data.signaturit;
            _t.paso++;
          } else {
            _t.mensajeerror = "ERROR: " + response.data.error;
          }
        })
        .catch(function(error) {
          console.log("enviar-documento-a-firmar - error", error);
          _t.mensajeerror =
            "Error 1002. No se pudo enviar el documento a firmar por Signaturit.<br />" +
            error;
        })
        .then(function() {
          _t.isEnviando = false;
        });
    },
  },
  watch: {},
  computed: {
    ...mapState(["user"]),
    usuario_nombre: {
      get() {
        if (!this.user) return "";
        console.log("get", this.user);
        return this.user.nombre;
      },
    },
    usuario_token: {
      get() {
        if (!this.user) return "";
        return this.user.token;
      },
    },
    usuario_email: {
      get() {
        if (!this.user) return "";
        return this.user.email;
      },
    },
  },
};
</script>

<style scoped></style>
